import { useQuery } from '@tanstack/react-query';
import ms from 'ms';

import { type Event } from 'hb-react/shared/apps/Events/types';
import { axiosWithSyntaxHandlers } from 'hb-react/shared/utils/axios';

import { type GetEventsEventAttendeesResponse } from './contracts';

export const useGetEventsAttendeesQuery = ({
  id,
  type,
  staleTime = ms('1h'),
}: Pick<Event, 'id' | 'type'> & { staleTime?: number }) =>
  useQuery({
    queryKey: ['event', 'attendees', type, id],
    retry: false,
    queryFn: () =>
      axiosWithSyntaxHandlers
        .get<GetEventsEventAttendeesResponse>(
          Routes.events_event_attendees_path(id, {
            params: {
              event_type: type,
            },
          }),
        )
        .then((r) => r.data),
    staleTime,
    select: (response) => ({
      ...response,
      data: response.data.map(({ avatar, obfuscatedName, ...user }) => ({
        ...user,
        photo_thumb_url: avatar,
        name: obfuscatedName,
      })),
    }),
  });
